<template>
	<div id="splash-screen">
        <v-icon name="sync" scale="4" spin style="color:#a0a0a0;opacity:0.5"/>
        <p style="margin-top:15px;color:#a0a0a0;font-size:2em;">{{action}}</p>
    </div>
</template>

<script>
export default {
  props :["action"],
	components:{},

  data () {
    return {
    }
  }
}
</script>

<style scoped>
#splash-screen{
    /* position:fixed;
    top:0;
    left:0; */
    height:100%;
    width:100%;
    display:flex;
    flex-direction:column;
    justify-content: center;
    align-content: center;
    align-items: center;
/*     z-index:1000000;
    background-color:#e7e7e7 !important;
    opacity: 0.9; */
}
</style>



// WEBPACK FOOTER //
// src/component/FullScreenLoading.vue